import React, { useState } from 'react'
import { Modal, Button, CheckBox } from '@clickcease/cc-client-components-lib'
import {
  StyledPendingInvitationsModalWrapper,
  StyledPendingInvitationsSubtitle,
  StyledPendingInvitationsTable,
  StyledPendingInvitationsTableBody,
  StyledPendingInvitationsTableRow,
  StyledPendingInvitationsTableCell,
  StyledPendingInvitationsActions,
} from '../PendingInvitations.styled'
import { useTranslation } from 'react-i18next'

interface InvitationAcceptanceModalProps {
  pendingInvitations: Array<{
    accountId: number
    accountName: string
    accepted: boolean
  }>
  onAccept: (selectedInvite: number[]) => void
  isOpen: boolean
  onClose: () => void
}

export const InvitationAcceptanceModal: React.FC<InvitationAcceptanceModalProps> = ({
  pendingInvitations,
  onAccept,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation('pricing')
  const { t: tAuth } = useTranslation('auth')
  const [selectedInvite, setSelectedInvite] = useState<number[]>([])

  const handleToggleInvite = (accountId: number) => {
    setSelectedInvite((prev) =>
      prev.includes(accountId) ? prev.filter((id) => id !== accountId) : [...prev, accountId]
    )
  }

  const handleAcceptInvite = () => {
    if (selectedInvite.length > 0) {
      onAccept(selectedInvite)
    }
  }

  return (
    <Modal
      title="Pending Invitations"
      isOpen={isOpen}
      onOpenChange={onClose}
      id="pending-invitations-modal"
      style={{ zIndex: 50 }}
    >
      <StyledPendingInvitationsModalWrapper>
        <StyledPendingInvitationsSubtitle>
          {t('pending_invitations.which_invite_to_approve')}
        </StyledPendingInvitationsSubtitle>
        <StyledPendingInvitationsTable>
          <StyledPendingInvitationsTableBody>
            {pendingInvitations.map((invite) => (
              <StyledPendingInvitationsTableRow key={invite.accountId}>
                <StyledPendingInvitationsTableCell>
                  <CheckBox
                    isChecked={selectedInvite.includes(invite.accountId)}
                    onChange={() => handleToggleInvite(invite.accountId)}
                  />
                  {invite.accountName}
                </StyledPendingInvitationsTableCell>
              </StyledPendingInvitationsTableRow>
            ))}
          </StyledPendingInvitationsTableBody>
        </StyledPendingInvitationsTable>
        <StyledPendingInvitationsActions>
          <Button
            text={tAuth('login.confirm')}
            disabled={selectedInvite.length === 0}
            onClick={handleAcceptInvite}
          />
        </StyledPendingInvitationsActions>
      </StyledPendingInvitationsModalWrapper>
    </Modal>
  )
}
